import {ICardLogo} from "../../components/CardLogo/interfaces";
import {EnumUrlsPages} from "../Enum";
import {SvgBitrix} from "../../components/BlockIntegration/logos/1c-bitrix";
import {SvgFulllog} from "../../components/BlockIntegration/logos/fulllog";
import {SvgDSS} from "../../components/BlockIntegration/logos/dss";
import {defaultValueForImage, isGeneration} from "./functions";

const LogosApiMain: ICardLogo[] = [
  {
    logo: isGeneration ? defaultValueForImage : require(`./img/BlockIntegration/dalli-api.svg`).default,
    width: 60,
    link: `${EnumUrlsPages.integration}#dalli_api`,
    linkOut: false,
  },
  {
    logo: isGeneration ? defaultValueForImage : SvgBitrix,
    width: 80,
    link: `${EnumUrlsPages.integration}#1c_bitrix`,
    linkOut: false,
  },
  {
    logo: isGeneration ? defaultValueForImage : require(`./img/BlockIntegration/retail-crm.svg`).default,
    width: 70,
    link: `${EnumUrlsPages.integration}#retail_crm`,
    linkOut: false,
  },
  {
    logo: isGeneration ? defaultValueForImage : require(`./img/BlockIntegration/sber-2-b.svg`).default,
    width: 60,
    link: `${EnumUrlsPages.integration}#insales`,
    linkOut: false,
  },
];

const LogosApiIntegration: ICardLogo[] = LogosApiMain.map((x) => (x = { ...x, hash: true }));

const LogosPartnersApi: ICardLogo[] = [
  {
    logo: isGeneration ? defaultValueForImage : require(`./img/BlockIntegration/api-ship.svg`).default,
    width: 60,
    link: 'https://apiship.ru/couriers',
    linkOut: true,
  },
  {
    logo: isGeneration ? defaultValueForImage : require(`./img/BlockIntegration/reworker.svg`).default,
    width: 60,
    link: 'https://www.reworker.ru/',
    linkOut: true,
  },
  {
    logo: isGeneration ? defaultValueForImage : require(`./img/BlockIntegration/tempoline.svg`).default,
    width: 70,
    link: 'https://tempoline.ru/',
    linkOut: true,
  },
  {
    logo: isGeneration ? defaultValueForImage : require(`./img/BlockIntegration/giper-fm.svg`).default,
    width: 60,
    link: 'https://giper.fm/',
    linkOut: true,
  },
  {
    logo: isGeneration ? defaultValueForImage : require(`./img/BlockIntegration/metaship.svg`).default,
    width: 40,
    link: 'https://metaship.ru/#deliveries',
    linkOut: true,
  },
  {
    logo: isGeneration ? defaultValueForImage : SvgFulllog,
    width: 65,
    link: 'https://fulllog.ru/delivery',
    linkOut: true,
  },
  {
    logo: isGeneration ? defaultValueForImage : SvgDSS,
    width: 60,
    link: 'https://zao-sdt.ru/',
    linkOut: true,
  },
  {
    logo: isGeneration ? defaultValueForImage : require(`./img/BlockIntegration/fm-logistic.svg`).default,
    width: 60,
    link: 'https://www.fmlogistic.ru/',
    linkOut: true,
  },
];

export default {
  textSubtitle1: 'С помощью готовых модулей и API',
  textSubtitle2: 'Интегрируйся через наших партнеров',
  logos: {
    apiMain: LogosApiMain,
    apiIntegration: LogosApiIntegration,
    apiPartners: LogosPartnersApi
  }
}
